import React from 'react';
import { COLORS } from '../utils/constants';

const Loading = ({ style }) => (
  <div style={{
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 100,
    ...style,
  }}>
    <div style={{
      width: 40,
      height: 40,
      border: `4px solid ${COLORS.lightGray}`,
      borderTop: `4px solid ${COLORS.primary}`,
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default Loading;
